import React, { useMemo } from 'react';
import _ from 'lodash';
import { useContextSelector } from 'use-context-selector';

import styles from './NavFooter.module.scss';
import Progress from '../UI/Progress/Progress';
import Button from '../UI/Button/Button';
import Audio from '../Audio/Audio';
import Label from '../context/Label/Label';
import { UIContext } from '../context/UI/UIContext';

type NavFooterProps = {
  globalState: any;
};

function NavFooter({ globalState }: NavFooterProps) {
  const {
    goNextPage,
    goPrevPage,
    getColorScheme,
    getCoursePercentage,
    getCurrentPage,
    course,
    getTracking,
    isInFirstPage,
    isInLastPage,
    isNavigationModeFree,
  } = globalState;
  const { primary } = getColorScheme();
  const currentPage = getCurrentPage();
  const pageTracking = getTracking(currentPage.resourceId);
  const stopBlinkNext = useContextSelector(UIContext, (c) => c.stopBlinkNext);
  const blinkNext = useContextSelector(UIContext, (c) => c.blinkNext);

  const hasAudio = !_.isEmpty(currentPage?.audio?.name);

  const showNavButtons = useMemo(
    () => _.size(course?.pages) > 1,
    [course?.pages]
  );

  return (
    <div className={styles.NavFooter} style={{ backgroundColor: primary }}>
      <Progress
        percent={getCoursePercentage()}
        showText
        color="#ffffff"
        className={styles.NavFooter__progress}
      />
      {hasAudio && (
        <div className={styles.NavFooter__audio}>
          <Audio url={`${course.baseURL}/${currentPage?.audio.name}`} />
        </div>
      )}
      {showNavButtons ? (
        <div className={styles.NavFooter__navbuttons} data-testid="navButtons">
          <Button
            onClick={() => {
              goPrevPage();
              stopBlinkNext();
            }}
            globalState={globalState}
            className={styles.NavFooter__button}
            disabled={isInFirstPage()}
          >
            <Label>previous</Label>
          </Button>
          <Button
            onClick={() => {
              goNextPage();
              stopBlinkNext();
            }}
            globalState={globalState}
            className={[
              styles.NavFooter__button,
              styles.NavFooter__nextButton,
              blinkNext ? styles.NavFooter__button__blink : '',
            ].join(' ')}
            disabled={
              (!pageTracking.completed && !isNavigationModeFree) ||
              isInLastPage()
            }
            testId="next-button"
          >
            <Label>next</Label>
          </Button>
        </div>
      ) : null}
    </div>
  );
}

export default NavFooter;
